import React from "react"
import { useSelector, useDispatch } from "react-redux"
import { Row, Col } from "react-bootstrap"

import { NUMBER, SCIENTIFIC } from "const"
import {
    StoreType,
    ChangeUserSettings,
    updateUserSettings,
} from "client/store"
import {
    FormGroup,
    Label,
    RadioButton,
    IncreaseInput,
    CheckboxWrapper,
} from "client/components"

import DecimalExample from "./decimalExample"


const Probability = () => {
    const settings = useSelector((state: StoreType) => state.userSettings.settings.sil)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const onChange = (value: ChangeUserSettings) => {
        dispatch(updateUserSettings("sil", value))
    }

    const {
        probability,
        probabilityDecimal,
    } = settings

    return (
        <Row>
            <Col xs={4}>
                <FormGroup>
                    <Label>{lang.probabilityFields}</Label>
                    <CheckboxWrapper displayColumn>
                        <RadioButton
                            checked={probability === NUMBER}
                            onChange={() => onChange({ probability: NUMBER })}
                            title={lang.number}
                        />
                        <RadioButton
                            checked={probability === SCIENTIFIC}
                            onChange={() => onChange({ probability: SCIENTIFIC })}
                            title={lang.scientific}
                        />
                    </CheckboxWrapper>
                </FormGroup>
            </Col>
            <Col xs={8}>
                <FormGroup>
                    <Label>{lang.decimal}</Label>
                    <Row>
                        <Col xs={6}>
                            <IncreaseInput
                                onChange={(val) => onChange({ probabilityDecimal: val })}
                                value={probabilityDecimal}
                            />
                        </Col>
                        <Col xs={6}>
                            <DecimalExample format={probability} decimal={probabilityDecimal} />
                        </Col>
                    </Row>
                </FormGroup>
            </Col>
        </Row>
    )
}
export default Probability
